import { RefundRequestStatus } from '@ivy-monorepo/shared'
import { REFUND_STATUS_LABELS } from '../utils/refundStatus'

const RefundStatusTag = ({ status }: { status?: RefundRequestStatus }) =>
  status ? <span className={`property-tag refund-${status.toLowerCase()}`}>{REFUND_STATUS_LABELS[status]}</span> : null

export default RefundStatusTag
